import base from '../dr-base'
import drGridLayoutColumn from './dr-grid-layout-column.vue'

const schema = {
  $Type: 'dr-grid-layout-column',
  name: 'Grid column',
  group: 'Container widgets',
  allowInToolbox: false,
  properties: {
    ...base.properties,
    Widgets: {
      type: 'array',
      items: {
        type: 'object'
      }
    },
    WeightOnMobile: {
      name: 'vuetifyWidgets.dr-grid-layout.widthOnMobile',
      type: 'integer',
      allowedInDesigner: true
    },
    WeightOnTablet: {
      name: 'vuetifyWidgets.dr-grid-layout.widthOnTablet',
      type: 'integer',
      allowedInDesigner: true
    },
    Weight: {
      name: 'vuetifyWidgets.dr-grid-layout.width',
      type: 'integer',
      allowedInDesigner: true
    }
  }
}

export default {
  schema,
  component: drGridLayoutColumn
}
